import { render, staticRenderFns } from "./EmailSidebar.vue?vue&type=template&id=6fa3bb1a"
import script from "./EmailSidebar.vue?vue&type=script&lang=js"
export * from "./EmailSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports